import { animate, state, style, transition, trigger } from '@angular/animations';
import { Component, OnInit, ViewChild } from '@angular/core';
import { MatPaginator } from '@angular/material/paginator';
import { MatSort } from '@angular/material/sort';
import { MatTableDataSource } from '@angular/material/table';
import { Product } from 'app/models/product.models';
import { ReportesService } from 'app/services/reportes.service';

@Component({
  selector: 'app-reporte-stock',
  templateUrl: './reporte-stock.component.html',
  styleUrls: ['./reporte-stock.component.css'],
  animations: [
    trigger('detailExpand', [
      state('collapsed', style({ height: '0px', minHeight: '0' })),
      state('expanded', style({ height: '*' })),
      transition(
        'expanded <=> collapsed',
        animate('225ms cubic-bezier(0.4, 0.0, 0.2, 1)')
      ),
    ]),
  ],
})
export class ReporteStockComponent implements OnInit {
  @ViewChild(MatPaginator) paginator: MatPaginator;
  @ViewChild(MatSort) sort: MatSort;

  displayedColumns: string[] = ['name', 'stock', 'expand'];

  dataSource: MatTableDataSource<Product>;

  productos: Product[] = [];
  loading: boolean;

  constructor(private reporteService: ReportesService) {}

  ngOnInit(): void {
    const sidebar = <HTMLElement>document.querySelector('.navbar-brand');
    if (sidebar !== undefined) {
      sidebar.innerHTML = 'reportes / productos sin stock';
    }
    this.dataSource = new MatTableDataSource();
    this.getProductosSinStock();
  }

  ngAfterViewInit() {
    this.dataSource.paginator = this.paginator;
    this.dataSource.sort = this.sort;
  }

  getProductosSinStock() {
    this.loading = true;
    this.reporteService.getProductosSinStock().subscribe(
      (res: Product[]) => {
        this.loading = false;

        this.productos = res.map(producto => ({
          ...producto,
          expanded: true,
          stock: producto.variants
            ? producto.variants.reduce((acc, variante) => acc + variante.stock, 0)
            : producto.stock,
        }));

        this.dataSource = new MatTableDataSource(this.productos);
        this.dataSource.paginator = this.paginator;
      },
      err => console.log(err)
    );
  }

  toggleRow(element) {
    element.expanded = !element.expanded;
  }
}
